module.exports = __webpack_public_path__ + "static/media/flag-it.c00d8f84.svg";